import React, { useEffect } from 'react';
import ActionButton from 'components/ActionButton';
import { useDeleteTemplateMutation } from 'services/api/mailer';
import { useHandleRequestErrors } from 'utils/hooks';
import { ResponseError } from 'services/api/base';
import { CustomAlert } from 'components/AlertsCollection';

interface MailerTemplateDeleteButton {
  type: number | string,
  subType: number | string,
  setAlerts: React.Dispatch<React.SetStateAction<CustomAlert[]>>,
}

export default function DeleteButton({
  type, subType, setAlerts,
}: MailerTemplateDeleteButton) {
  const [deleteTemplateTrigger, {
    data: deletionData, error: deletionError,
  }] = useDeleteTemplateMutation();

  useEffect(() => {
    if (deletionData) {
      setAlerts([{
        title: deletionData?.title || '',
        message: deletionData?.message || '',
        variant: 'primary',
      }]);
    }
  }, [setAlerts, deletionData]);

  const deleteTemplate = () => {
    deleteTemplateTrigger({
      type,
      subtypeId: subType,
    });
  };

  useHandleRequestErrors(deletionError as ResponseError);

  return (
    <ActionButton
      icon="trash"
      onClick={deleteTemplate}
      tooltipText="Excluir template"
      className="ms-2"
    />
  );
}
